import { FaAward, FaCheckCircle, FaGlobe, FaHeadset, FaShieldAlt, FaUsers } from 'react-icons/fa';
import './WhyChooseUs.css';

const WhyChooseUs = () => {
  const reasons = [
    {
      icon: <FaAward />,
      title: 'Industry Experience',
      description: 'Over 15 years of excellence in travel and tourism services, trusted by thousands of satisfied customers.'
    },
    {
      icon: <FaGlobe />,
      title: 'Global Network',
      description: 'Partnerships with airlines, hotels, and service providers worldwide ensuring the best deals and experiences.'
    },
    {
      icon: <FaHeadset />,
      title: '24/7 Support',
      description: 'Round-the-clock customer support to assist you before, during, and after your journey.'
    },
    {
      icon: <FaShieldAlt />,
      title: 'Secure Booking',
      description: 'Safe and secure payment processing with complete protection of your personal information.'
    },
    {
      icon: <FaUsers />,
      title: 'Expert Team',
      description: 'Professional travel consultants with extensive knowledge to plan your perfect trip.'
    },
    {
      icon: <FaCheckCircle />,
      title: 'Best Price Guarantee',
      description: 'Competitive pricing with no hidden charges. Get the best value for your money.'
    }
  ];

  const stats = [
    { number: '15+', label: 'Years Experience' },
    { number: '10,000+', label: 'Happy Customers' },
    { number: '100+', label: 'Destinations' },
    { number: '24/7', label: 'Customer Support' }
  ];

  return (
    <div className="why-choose-us">
      {/* Hero Section */}
      <section className="why-hero">
        <div className="why-hero-overlay">
          <div className="container">
            <h1 className="why-hero-title">Why Choose KSA Holidays?</h1>
            <p className="why-hero-subtitle">
              Your trusted partner for unforgettable travel experiences
            </p>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="stats-section">
        <div className="container">
          <div className="stats-grid">
            {stats.map((stat, index) => (
              <div key={index} className="stat-card">
                <h3 className="stat-number">{stat.number}</h3>
                <p className="stat-label">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Reasons Section */}
      <section className="reasons-section">
        <div className="container">
          <div className="section-header">
            <h2>What Makes Us Different</h2>
            <p>Discover why travelers choose KSA Holidays for their journeys</p>
          </div>

          <div className="reasons-grid">
            {reasons.map((reason, index) => (
              <div key={index} className="reason-card">
                <div className="reason-icon">{reason.icon}</div>
                <h3 className="reason-title">{reason.title}</h3>
                <p className="reason-description">{reason.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Commitment Section */}
      <section className="commitment-section">
        <div className="container">
          <div className="commitment-content">
            <h2>Our Commitment to You</h2>
            <div className="commitment-text">
              <p>
                At KSA Holidays, we believe that travel is more than just visiting new places –
                it's about creating memories that last a lifetime. Our family-owned business has been
                dedicated to providing exceptional travel experiences since our inception.
              </p>
              <p>
                We understand that every traveler is unique, which is why we offer personalized service
                tailored to your specific needs and preferences. From the moment you contact us until
                you return home with unforgettable memories, we're with you every step of the way.
              </p>
              <div className="commitment-features">
                <div className="commitment-feature">
                  <FaCheckCircle className="feature-icon" />
                  <span>Transparent Pricing</span>
                </div>
                <div className="commitment-feature">
                  <FaCheckCircle className="feature-icon" />
                  <span>Flexible Booking Options</span>
                </div>
                <div className="commitment-feature">
                  <FaCheckCircle className="feature-icon" />
                  <span>Quality Assured Services</span>
                </div>
                <div className="commitment-feature">
                  <FaCheckCircle className="feature-icon" />
                  <span>Customer Satisfaction Guaranteed</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="container">
          <div className="cta-content">
            <h2>Ready to Start Your Journey?</h2>
            <p>Let us help you create unforgettable travel experiences</p>
            <div className="cta-buttons">
              <a href="/tours" className="btn btn-primary">Explore Tours</a>
              <a href="/contact" className="btn btn-secondary">Contact Us</a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default WhyChooseUs;
